<script setup lang="ts">
import { computed, onMounted, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import Drawer from 'primevue/drawer';
import { Typography } from '@apparatix/library/core';
import { InventoryHeaderConfig } from './InventoryHeaderConfig';

const router = useRouter();
const route = useRoute();

const isVisible = ref(false);

const invNumber = computed(() => (route.query.invNumber as string) || '');

const onDrawerHide = () => {
  if (route?.meta?.basePath) {
    // The timeout allows the drawer close animation to finish before we drop the
    // detail route, mirroring the CRM FlyoutHost behaviour.
    setTimeout(() => router.replace({ path: route.meta.basePath as string }), 250);
  }
};

onMounted(() => isVisible.value = true);
</script>
<template>
  <Drawer
    v-model:visible="isVisible"
    position="right"
    class="crm-drawer-container"
    :pt="{
      root: {
        class: 'border-0 overscroll-none'
      },
      mask: {
        class: 'overscroll-none crm-drawer-mask'
      }
    }"
    modal
    @hide="onDrawerHide"
  >
    <template #container>
      <div class="flex flex-col w-full h-full overflow-y-auto bg-[var(--white)]">
        <div class="w-full h-[35px] shrink-0 flex items-center border-b border-[var(--p-content-border-color)]">
          <div
            class="grow-0 flex items-center justify-center w-[35px] h-full border-r border-[var(--p-content-border-color)] cursor-pointer"
            @click="isVisible = false"
          >
            <span class="pi pi-times" aria-label="Close drawer" />
          </div>
          <div
            class="grow flex gap-1 items-center h-full pl-3"
            :style="{ backgroundColor: InventoryHeaderConfig.backgroundColor }"
          >
            <Typography variant="breadcrumb">
              {{ InventoryHeaderConfig.singular }}
            </Typography>
            <template v-if="invNumber">
              <span class="pi pi-angle-right" />
              <Typography variant="breadcrumb" :truncate="true">
                {{ invNumber }}
              </Typography>
            </template>
          </div>
          <div
            class="grow-0 h-full w-[35px] flex items-center justify-center bg-[var(--white)] border-l border-[var(--p-content-border-color)] cursor-pointer"
            @click="router.back"
          >
            <span class="pi pi-arrow-left" aria-label="Back" />
          </div>
        </div>
        <RouterView />
      </div>
    </template>
  </Drawer>
</template>
